!(function () {
  "use strict";
  class ProductModelViewer extends window.theme.DeferredMedia {
    constructor() {
      super();
    }
    loadContent() {
      super.loadContent(),
        Shopify.loadFeatures([
          {
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
    }
    setupModelViewerUI(hasError) {
      hasError ||
        (this.modelViewerUI = new Shopify.ModelViewerUI(
          this.querySelector("model-viewer")
        ));
    }
  }
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(hasError) {
      hasError ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((modelElement) => {
              window.ShopifyXR.addModels(JSON.parse(modelElement.textContent)), modelElement.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const addToCartSelector = "[data-add-to-cart]",
    productJsonSelector = "[data-product-json]",
    productFormSelector = "[data-product-form]",
    subscriptionsSelector = "[data-subscription-selectors]",
    cartBarSelector = "#cart-bar",
    popupOpenSelector = "[data-popup-open]",
    productSubmitSelector = ".product__submit__add",
    formWrapperSelector = "[data-form-wrapper]",
    productVariantsSelector = "[data-product-variants]",
    loadingClass = "is-loading",
    visibleClass = "is-visible",
    cartBarEnabledAttribute = "data-cart-bar-enabled",
    addToCartBarAttribute = "data-add-to-cart-bar",
    cartBarScrollAttribute = "data-cart-bar-scroll",
    cartBarSubscriptionsSelector = "[data-cart-bar-subscriptions]",
    cartBarProductNotificationAttribute = "data-cart-bar-product-notification",
    stickyEnabledAttribute = "data-sticky-enabled";
  customElements.get("product-component") ||
    customElements.define(
      "product-component",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.stickyEnabled = "true" === this.getAttribute(stickyEnabledAttribute)),
            (this.formWrapper = this.querySelector(formWrapperSelector)),
            (this.cartBarEnabled = this.hasAttribute(cartBarEnabledAttribute)),
            (this.cartBar = this.querySelector(cartBarSelector)),
            (this.setCartBarHeight = this.setCartBarHeight.bind(this)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.mobileMatchQuery = window.matchMedia("(max-width: 749px)")),
            (this.unlockTimer = 0);
        }
        connectedCallback() {
          const productJsonElement = this.querySelector(productJsonSelector);
          if ((productJsonElement && !productJsonElement.innerHTML) || !productJsonElement) return;
          const productHandle = JSON.parse(productJsonElement.innerHTML).handle;
          let recentlyViewedProduct = {};
          productHandle && (recentlyViewedProduct = { handle: productHandle }),
            Shopify.Products.recordRecentlyViewed(recentlyViewedProduct),
            Shopify.Products &&
              Shopify.Products.recordRecentlyViewed &&
              Shopify.Products.recordRecentlyViewed(recentlyViewedProduct),
            (this.form = this.querySelector(productFormSelector)),
            (this.subscriptions = this.querySelector(subscriptionsSelector)),
            this.cartBarEnabled &&
              (this.initCartBar(),
              this.setCartBarHeight(),
              this.initCartBarObserver(),
              document.addEventListener("theme:resize", this.setCartBarHeight));
        }
        initCartBarObserver() {
          // Show the sticky cart bar ONLY after the main add-to-cart button has
          // fully scrolled above the top of the viewport (i.e. is no longer in view).
          // Hidden while the main ATC is visible or still below the fold, so the
          // sticky bar and the primary ATC are never on screen at the same time.
          // Mobile only: the bar is hidden on desktop, so never toggle it there.
          const mainAddToCart = this.form ? this.form.querySelector(addToCartSelector) : null;
          const anchor = mainAddToCart || this.form;
          if (!anchor || !this.cartBar) return;
          this.cartBarObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const scrolledPast =
                  window.theme.isMobile() && !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.cartBar.classList.toggle(visibleClass, scrolledPast);
              });
            },
            { root: null, threshold: 0 }
          );
          this.cartBarObserver.observe(anchor);
        }
        initCartBar() {
          (this.cartBarBtns = this.cartBar.querySelectorAll(productSubmitSelector)),
            this.cartBarBtns.length > 0 &&
              this.cartBarBtns.forEach((cartBarButton) => {
                cartBarButton.addEventListener("click", (clickEvent) => {
                  clickEvent.preventDefault(),
                    clickEvent.currentTarget.hasAttribute(addToCartBarAttribute)
                      ? (this.cartBarEnabled &&
                          (clickEvent.currentTarget.classList.add(loadingClass),
                          clickEvent.currentTarget.setAttribute("disabled", "disabled")),
                        this.form
                          .querySelector(addToCartSelector)
                          .dispatchEvent(new Event("click", { bubbles: !0 })))
                      : clickEvent.currentTarget.hasAttribute(cartBarScrollAttribute)
                      ? this.scrollToTop()
                      : clickEvent.currentTarget.hasAttribute(cartBarProductNotificationAttribute) &&
                        this.form
                          .querySelector(popupOpenSelector)
                          ?.dispatchEvent(new Event("click"));
                }),
                  cartBarButton.hasAttribute(addToCartBarAttribute) &&
                    document.addEventListener(
                      "theme:product:add-error",
                      this.scrollToTop
                    );
              }),
              this.querySelector(cartBarSubscriptionsSelector) && this.querySelectorAll(`${cartBarSubscriptionsSelector} a`).forEach((link) => {
                link.addEventListener('click', (e) => {
                  e.preventDefault();
                  const scrollToElement = document.querySelector(e.target.getAttribute('href'));
                  if (!scrollToElement) {
                    return;
                  }
                  window.theme.scrollTo(scrollToElement.getBoundingClientRect().top);
                })
              })

            this.setCartBarHeight();
        }
        scrollToTop() {
          const productVariantsElement = this.querySelector(productVariantsSelector),
            scrollPosition = (
              window.theme.isMobile() ? productVariantsElement || this.form : this
            ).getBoundingClientRect().top;
          window.theme.scrollTo(window.theme.isMobile() ? scrollPosition - 10 : scrollPosition);
        }
        setCartBarHeight() {
          const cartBarHeight = this.cartBar.offsetHeight;
          document.documentElement.style.setProperty(
            "--cart-bar-height",
            `${cartBarHeight}px`
          );
        }
        disconnectedCallback() {
          document.removeEventListener(
            "theme:product:add-error",
            this.scrollToTop
          ),
            this.cartBarEnabled &&
              (this.cartBarObserver && this.cartBarObserver.disconnect(),
              document.removeEventListener(
                "theme:resize",
                this.setCartBarHeight
              ));
        }
      }
    ),
    customElements.get("product-model") ||
      customElements.define("product-model", ProductModelViewer);
})();
